import React from 'react';
import {
  Box,
  Button,
  Paper,
  MenuList,
  MenuItem,
  ListItemText,
  Popper,
  Grow,
  ClickAwayListener,
} from '@mui/material';
import {
  Print as PrintIcon,
  FileDownload as ExportIcon,
} from '@mui/icons-material';

interface ToolbarDetailOrderProps {
  onMailing?: () => void;
  onPrint?: (type: string) => void;
  onDelete?: () => void;
  onRefresh?: () => void;
  onViewList?: () => void;
  onExport?: () => void;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  canPrint?: boolean;
  canExport?: boolean;
  canDelete?: boolean;
}

const PRINT_OPTIONS = [
  {type: 'order', label: 'In đơn hàng'},
  {type: 'order_survey', label: 'In đơn khảo sát'},
  {type: 'order_quotation', label: 'In đơn báo giá'},
] as const;

export default function ToolbarDetailOrder({
  onPrint,
  onDelete,
  onExport,
  canPrint = false,
  canExport = false,
  canDelete = false,
}: ToolbarDetailOrderProps) {
  const [printMenuOpen, setPrintMenuOpen] = React.useState(false);
  const printAnchorRef = React.useRef<HTMLButtonElement>(null);
  const closeTimeoutRef = React.useRef<ReturnType<typeof setTimeout>>(undefined);

  const handleMouseEnter = () => {
    clearTimeout(closeTimeoutRef.current);
    setPrintMenuOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => setPrintMenuOpen(false), 150);
  };

  const handlePrintOption = (type: string) => {
    setPrintMenuOpen(false);
    onPrint?.(type);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      {canPrint && (
        <Box
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{ position: 'relative' }}
        >
          <Button
            ref={printAnchorRef}
            variant="outlined"
            startIcon={<PrintIcon />}
            sx={{
              borderRadius: 0.5,
              textTransform: 'none',
              fontWeight: 'bold',
              minHeight: '22px !important',
              minWidth: 'auto !important',
              padding: '4px 8px !important',
              height: '30px !important',
              borderColor: '#d1d5db',
              color: '#374151',
              '&:hover': {
                borderColor: '#9ca3af',
                backgroundColor: '#f9fafb',
              },
            }}
          >
            In
          </Button>
          <Popper
            open={printMenuOpen}
            anchorEl={printAnchorRef.current}
            placement="bottom-start"
            transition
            disablePortal
            sx={{ zIndex: 1300 }}
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} style={{ transformOrigin: 'left top' }}>
                <Paper
                  elevation={4}
                  sx={{ mt: 0.5, minWidth: 180 }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <ClickAwayListener onClickAway={() => setPrintMenuOpen(false)}>
                    <MenuList dense>
                      {PRINT_OPTIONS.map((opt) => (
                        <MenuItem key={opt.type} onClick={() => handlePrintOption(opt.type)}>
                          <ListItemText>{opt.label}</ListItemText>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      )}
      {canExport && (
        <Button
          variant="outlined"
          startIcon={<ExportIcon />}
          onClick={onExport}
          sx={{
            borderRadius: 0.5,
            textTransform: 'none',
            fontWeight: 'bold',
            minHeight: '22px !important',
            minWidth: 'auto !important',
            padding: '4px 12px !important',
            height: '30px !important',
            borderColor: '#d1d5db',
            color: '#374151',
            '&:hover': {
              borderColor: '#9ca3af',
              backgroundColor: '#f9fafb',
            },
          }}
        >
          Export
        </Button>
      )}
      {/* {canDelete && (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          onClick={onDelete}
          sx={{
            borderRadius: 0.5,
            textTransform: 'none',
            fontWeight: 'bold',
            minHeight: '22px !important',
            minWidth: 'auto !important',
            padding: '4px 12px !important',
            height: '30px !important',
            borderColor: '#d1d5db',
            color: '#d32f2f',
            '&:hover': {
              borderColor: '#f44336',
              backgroundColor: '#ffebee',
            },
          }}
        >
          Xóa
        </Button>
      )} */}
    </Box>
  );
}
